module.exports = __webpack_public_path__ + "img/delete.244a70d2.png";